const contentTransitionDurationMs = 375;
const content = "jzpcn9fl1u";
const wrapper = "jzpwa3c2mr";
const lightboxWrapper = "jzplc4tlsk";
const card = "jzpc1setc4p";

export { card, content, contentTransitionDurationMs, lightboxWrapper, wrapper };
import "./comp.router.style.linaria.module.css";
//# sourceMappingURL=comp.router.style.js.map
